const id_trans_returnsuplist = {
    "": "supervisi retur pemasok",
    view: "detail retur pemasok",
    add: "tambah retur pemasok",
}

export default id_trans_returnsuplist;